// Multi-home async actions. The app has no thunk middleware, so these helpers
// do fetch + dispatch directly via the store singleton (see store/instance).
import { fetcher } from "@/components/utility";
import { getStore } from "@/store/instance";
import {
  setHome,
  setHomes,
  homeSetNotifications,
  homeSetSlots,
} from "@/actions/home";
import { setConversationPreview } from "@/actions/conversation";

/** Fetch the user's property summaries and put them in state.Homes. */
export async function fetchProperties() {
  const res = await fetcher({
    path: "/api/homes",
    method: "GET",
    credentials: true,
  });
  if (res?.success) {
    getStore()?.dispatch(setHomes(res.homes || []));
  }
  return res;
}

/**
 * Switch the active property: activate it server-side, then re-hydrate the
 * active home (+ ads / notifications / conversations) the same way the initial
 * session load does (see App.LogIn / GET /api/loggedIn).
 */
export async function switchActiveProperty(id: number) {
  const act = await fetcher({
    path: `/api/homes/${id}/activate`,
    method: "POST",
    credentials: true,
  });
  if (!act?.success) return act;

  const res = await fetcher({ path: "/api/loggedIn", credentials: true });
  const store = getStore();
  if (res?.success && res.home) {
    if (res.ads != null) res.home.advertises = res.ads;
    // Same tenant enrichment App.LogIn does on initial hydration: attach the
    // pickedUser/image fields the HpTenants UI expects.
    if (Array.isArray(res.home.tenants) && Array.isArray(res.home_tenants)) {
      res.home.tenants.forEach((tenant: any, i: number) => {
        if (!tenant.user_id) return;
        const ht = res.home_tenants.find((x: any) => x._id == tenant.user_id);
        if (!ht) return;
        res.home.tenants[i].pickedUser = {
          value: ht._id,
          image: ht.profile_image,
          image_webp: ht.profile_image_webp,
          location: ht.location,
          age: ht.age,
          type: ht.type,
          label: ht.name + " " + ht.surname,
        };
        res.home.tenants[i].image = ht.profile_image;
        res.home.tenants[i].image_webp = ht.profile_image_webp;
      });
    }
    store?.dispatch(setHome(res.home));
    if (res.notifications != null)
      store?.dispatch(homeSetNotifications(res.notifications));
    if (res.slotArray != null) store?.dispatch(homeSetSlots(res.slotArray));
    if (res.conversations != null)
      store?.dispatch(setConversationPreview(res.conversations));
  }
  await fetchProperties(); // refresh the active flags in the list
  return res;
}

/** Delete a property (and its ads). Refreshes the list; caller handles nav. */
export async function deleteProperty(id: number) {
  const res = await fetcher({
    path: `/api/homes/${id}`,
    method: "DELETE",
    credentials: true,
  });
  if (res?.success) {
    await fetchProperties();
  }
  return res;
}
